// src/main.js
import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

// ========== 导入 Element Plus ==========
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'
// 导入中文语言包
import zhCn from 'element-plus/es/locale/lang/zh-cn'

console.log('🔴 main.js 执行')

// ========== 1. 过滤 WebSocket 控制台错误 ==========
const originalConsoleError = console.error
console.error = function(...args) {
  const message = args.join(' ')
  // 忽略所有 WebSocket 相关错误
  if (message.includes('WebSocket') || 
      message.includes('ws://') || 
      message.includes('websocket') ||
      message.includes('WebSocketClient')) {
    return
  }
  originalConsoleError.apply(console, args)
}

// ========== 2. 修复 DevTools 兼容性问题 ==========
const originalHook = window.__VUE_DEVTOOLS_GLOBAL_HOOK__
if (originalHook) {
  originalHook.enabled = true
} else {
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__ = {
    enabled: false,
    emit: () => {},
    on: () => {},
    once: () => {},
    off: () => {}
  }
}

// ========== 3. 创建应用 ==========
const app = createApp(App)

// ========== 4. 全局错误处理 ==========
app.config.errorHandler = (err, instance, info) => {
  if (err && typeof err === 'object') {
    const message = err.message || ''
    if (message.includes('__vrv_devtools') || 
        message.includes('Vue Devtools') ||
        message.includes('WebSocket') ||
        message.includes('ws://')) {
      console.warn('⚠️ 已忽略 DevTools/WebSocket 警告')
      return
    }
  }
  console.error('❌ Vue 错误:', err)
  console.error('📌 错误信息:', info)
}

// ========== 5. 使用 Element Plus（带中文） ==========
app.use(ElementPlus, {
  locale: zhCn,
})

// ========== 6. 使用路由 ==========
app.use(router)

// ============================================================
// 🆕 7. 全局 fetch 拦截器（自动修复 /api 重复问题）
// ============================================================
const originalFetch = window.fetch
window.fetch = function(url, options) {
  // 如果是字符串 URL 且包含 /api/api/，自动修正为 /api/
  if (typeof url === 'string' && url.includes('/api/api/')) {
    const correctedUrl = url.replace(/\/api\/api\//g, '/api/')
    console.warn('🔄 自动修正 API 路径:', url, '→', correctedUrl)
    return originalFetch.call(this, correctedUrl, options)
  }
  return originalFetch.call(this, url, options)
}
console.log('✅ fetch 拦截器已启用，将自动修复 /api/api/ 路径')

// ========== 8. 挂载应用 ==========
router.isReady().then(() => {
  app.mount('#app')
  console.log('✅ 应用挂载完成')
}).catch(err => {
  console.error('❌ 路由就绪失败:', err)
})